module.exports = __webpack_public_path__ + "img/synapse-homepage1.86624484.png";